import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AUTH_MIDDLEWARE_LOGIN_URL,
  AUTH_MIDDLEWARE_URL
} from '../../app.constants';
import {
  LoginRES,
  ResetPasswordREQ,
  ResetPasswordRES,
  VerifyOtpREQ,
  VerifyOtpRES,
  VerifyUserREQ,
  VerifyUserRES
} from '../models/api_models/';
import {
  GetLoginOtpREQ,
  GetLoginOtpRES
} from '../models/api_models/passcode/get-login-otp.res';
import {
  VerifyLoginOtpREQ,
  VerifyLoginOtpRES
} from '../models/api_models/passcode/verify-login-otp.res';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthDataService {
  constructor(private httpClient: HttpClient) {}

  login(credentials: { username: string; password: string }) {
    const url = `${AUTH_MIDDLEWARE_LOGIN_URL}`;
    return this.httpClient.post<LoginRES>(url, credentials);
  }

  resetPassword(req: ResetPasswordREQ) {
    const url = `${AUTH_MIDDLEWARE_URL}/resetPassword`;
    return this.httpClient.post<ResetPasswordRES>(url, req);
  }

  verifyOtp(req: VerifyOtpREQ) {
    const url = `${AUTH_MIDDLEWARE_URL}/verifyOtp`;
    return this.httpClient.post<VerifyOtpRES>(url, req);
  }

  verifyUser(req: VerifyUserREQ) {
    const url = `${AUTH_MIDDLEWARE_URL}/sendOtp`;
    return this.httpClient.post<VerifyUserRES>(url, req);
  }

  getLoginOtp(req: GetLoginOtpREQ): Observable<GetLoginOtpRES> {
    const url = `${AUTH_MIDDLEWARE_LOGIN_URL}/otp`;
    return this.httpClient.post<GetLoginOtpRES>(url, req);
  }

  verifyLoginOtp(req: VerifyLoginOtpREQ): Observable<VerifyLoginOtpRES> {
    const url = `${AUTH_MIDDLEWARE_LOGIN_URL}/verifyOtp`;
    return this.httpClient.post<VerifyLoginOtpRES>(url, req);
  }
}
